function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.334h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h256v170.663H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.329v15.083l57.377 38.251H80z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 255.997v-15.082l57.377-38.252H80z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
  fill: "#2e52b2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 255.997v-15.082l-57.377-38.252H176z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z",
  fill: "#2e52b2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 189.214v81.623c0 39.76 103.884 39.76 103.884 0v-81.623H332.058z",
  fill: "#f3f3f3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 270.837c0 39.76 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v.001H332.058v-.001z",
  fill: "#6da544"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M384 238.188l-24.116 10.388v22.261L384 285.678l24.116-14.841v-22.261z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M359.88 226.312h48.228v22.261H359.88z"
});

const SvgBermuda = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBermuda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bermuda.1f9a421d.svg";
export { ForwardRef as ReactComponent };